import React from 'react';
import { Pressable } from 'react-native';
import Colors from '../../../../../constants/Colors';
import PressableStyled, { PressableState } from '../../../../../components/PressableStyled';
import isMobile from '../../../../../components/IsMobile';

export default function TicketItemWrapper({
  children,
  style,
  onPress,
  selected: isSelected,
  index,
  status,
}: {
  children: any;
  style?: any;
  onPress: any;
  selected: boolean;
  index: any;
  status: string;
}) {
  return isMobile ? (
    <PressableStyled
      testID={`ticket#${index + 1}`}
      key={index}
      style={[
        { backgroundColor: '#fff' },
        isSelected && status === 'inprogress' && { backgroundColor: Colors.light.hereworksBlue500 },
        isSelected && status === 'paused' && { backgroundColor: Colors.light.hereworksYellow400 },
        isSelected && status === 'completed' && { backgroundColor: Colors.light.hereworksGreen400 },
        isSelected && (status !== 'inprogress' && status !== 'paused' && status !== 'completed')
        && { backgroundColor: Colors.light.hereworksDarkBlue },
        style,
      ]}
      {...{ onPress }}
    >
      {children}
    </PressableStyled>
  ) : (
    <Pressable
      testID={`ticket#${index + 1}`}
      role="link"
      key={index}
      style={({ pressed, hovered }: PressableState) => [
        isSelected && status === 'inprogress' && { backgroundColor: Colors.light.hereworksBlue500 },
        isSelected && status === 'paused' && { backgroundColor: Colors.light.hereworksYellow400 },
        isSelected && status === 'completed' && { backgroundColor: Colors.light.hereworksGreen400 },
        isSelected && (status !== 'inprogress' && status !== 'paused' && status !== 'completed')
        && { backgroundColor: Colors.light.hereworksDarkBlue },
        style,
        ((hovered || pressed) && !isSelected)
        && {
          backgroundColor: Colors.light.hereworksHover,
          borderColor: Colors.light.hereworksBlue500,
        },
      ]}
      {...{ onPress }}
    >
      {children}
    </Pressable>
  );
}
